import {
    Card,
    CardContent,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material';
import type { RevenueProjection } from '../utils/dealCalculations';

interface RevenueProjectionCardsProps {
    streamingRevenue: RevenueProjection[];
    liveRevenueAnnual: number;
}

const fmtDollar = (val: number): string =>
    val >= 0 ? `$${val.toLocaleString()}` : `-$${Math.abs(val).toLocaleString()}`;

export const RevenueProjectionCards = ({
    streamingRevenue,
    liveRevenueAnnual,
}: RevenueProjectionCardsProps) => {
    return (
        <Card>
            <CardContent>
                <Typography variant="h6" gutterBottom>
                    Revenue Projections (Your Backend Share)
                </Typography>
                <TableContainer>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Period</TableCell>
                                <TableCell align="right">Conservative</TableCell>
                                <TableCell align="right">Moderate</TableCell>
                                <TableCell align="right">Optimistic</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {streamingRevenue.map((row) => (
                                <TableRow key={row.period}>
                                    <TableCell>
                                        {row.period} months (Streaming)
                                    </TableCell>
                                    <TableCell align="right">
                                        {fmtDollar(row.conservative)}
                                    </TableCell>
                                    <TableCell align="right">
                                        {fmtDollar(row.moderate)}
                                    </TableCell>
                                    <TableCell align="right">
                                        {fmtDollar(row.optimistic)}
                                    </TableCell>
                                </TableRow>
                            ))}
                            {liveRevenueAnnual > 0 && (
                                <TableRow>
                                    <TableCell>Annual Live Revenue</TableCell>
                                    <TableCell align="right" colSpan={3}>
                                        {fmtDollar(liveRevenueAnnual)}
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </CardContent>
        </Card>
    );
};
